import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = () => ({
  downArrow: {
    color: "white",
    padding: 0,
    margin: "1rem 1rem 0.4rem 1rem",
    borderRight: "2px solid",
    borderBottom: "2px solid",
    width: "9px",
    height: "9px",
    transform: "rotate(45deg)",
    display: "block"
  }
});

const DownArrow = ({ classes }) => <div className={classes.downArrow} />;

DownArrow.propTypes = {
  classes: PropTypes.object
};

export default injectSheet(styles)(DownArrow);



// WEBPACK FOOTER //
// ./src/components/ProductBar/DownArrow.jsx